import React, { PureComponent } from 'react'
import { useEffect,useState } from 'react'
import styled from 'styled-components'
import ImageSlider from './Home/ImageSlider'
import Movies from './Home/Movies'
import Viewers from './Home/Viewers'
import { auth, provider, storage ,db1,analytics} from '../firebase'
import db from '../firebase'
import {onSnapshot,collection}  from 'firebase/firestore'
import { useDispatch } from 'react-redux'
import {setMovies} from '../features/movies/MovieSlice'

export default function Home() {
  const dispatch=useDispatch();

  useEffect(() => 
    onSnapshot(collection(db1, "movies"), (snapshot) => {
      const tem =dispatch(setMovies(snapshot.docs.map((doc) => doc.data())))
      
    }), []);

  return (
    <Container>
      <ImageSlider />
      <Viewers />
      <Movies />
    </Container>


  )
}


const Container = styled.main`
min-height: calc(100vh - 70px);
padding: 0 calc(3.5vw + 5px);
position: relative;
overflow-x: hidden;

&:before{
    background:url("/images/home-background.png") center center / cover no-repeat fixed;
    content:""; 
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:-1;

}
`
